<template>
	<!--内容-->
	<div class="bodybox cursorstyle">
		<!--    电子流程-->
		<div class="Electronics">
			<p>电子申请流程</p>
			<div class="ElectronicsItem">
				<div>材料提交</div>
				<div><img src="../assets/img/形状结合.png" alt=""></div>
				<div>
					<img src="../assets/img/材料审核.png" alt="">
					<span>材料初审，状态为“审核中”</span>
				</div>
				<div><img src="../assets/img/形状结合.png" alt=""></div>
				<div>
					<img src="../assets/img/上报.png" alt="">
					<div style="display: inline-block;float: right;">
						<div style="line-height: 0;margin-top: 16px;">上报国家知识产权平台</div>
						<div style="line-height: 37px;">状态为“国家知识产权平台审核”</div>
					</div>
				</div>
				<div><img src="../assets/img/形状结合.png" alt=""></div>
				<div>
					<img src="../assets/img/完成审批.png" alt="">
					<span>完成审批，状态为“已授权”</span>
				</div>
				<div><img src="../assets/img/形状结合.png" alt=""></div>
				<div>
					<img src="../assets/img/邮箱.png" alt="">
					<span>邮箱告知</span>
				</div>
			</div>
		</div>
		<!--    我的专利-->
		<div class="Notice_box stylePointer">
			<div class="Notice_box_title">
				<div>我的专利</div>
				<div @click="EnterBtn('patent')">
					<a href="#ApplicationManagement">专利申请</a>
				</div>
				<div class="cursorstyleObjBtn" @click="InputBtn('patent')">
					专利录入
				</div>
			</div>
			<div class="Notice_box_tpl">
				<!-- <div></div> -->
				<div>
					<el-table :data="tableDataPatent" style="width:100%" class="tablebox">
						<el-table-column label="序号" align="center" width="50px">
							<template slot-scope="scope">
								<span>{{scope.$index+1}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" show-overflow-tooltip label="专利名称" align="center">
						</el-table-column>
					<!-- 	<el-table-column prop="type" show-overflow-tooltip label="专利类型" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.type == '1'">发明专利</span>
								<span v-if="scope.row.type == '2'">实用新型专利</span>
								<span v-if="scope.row.type == '3'">外观设计专利</span>
							</template>
						</el-table-column> -->
						<el-table-column show-overflow-tooltip label="创建方式" align="center">
							<template slot-scope="scope">
                <span v-if="scope.row.create_type == '1'">自主申请</span>
                <span v-if="scope.row.create_type == '2'">自主录入</span>
                <span v-if="scope.row.create_type == '3'">后台录入</span>

              </template>
						</el-table-column>
						<el-table-column prop="status_txt" show-overflow-tooltip label="状态" align="center">
						</el-table-column>
						<el-table-column show-overflow-tooltip label="提交日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.create_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip label="授权日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.pass_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" >
							<template slot-scope="scope">
								<span  class="cursorstyleObjBtn" style="color: #409EFF;" @click="SeePatent(scope.row,'patent')"
									type="text" size="small"> 查看</span>
								<span v-if="scope.row.status == 2 || scope.row.status ==5" class="cursorstyleObjBtn" style="color: #409EFF;"
									@click="editPatent(scope.row,'patent')" type="text" size="small"> 编辑</span>

							</template>
						</el-table-column>

					</el-table>
				</div>
			</div>
			<div class="morebox cursorstyleObjBtn" @click="seeMore('patent')">
				查看更多<img src="../assets/rightbtn.png">
			</div>
		</div>
		<!--    我的商标-->
		<div class="Notice_box stylePointer">
			<div class="Notice_box_title ">
				<div>我的商标</div>
				<div @click="EnterBtn('trademark')">
					<a href="#ApplicationManagement">商标申请</a>
				</div>
				<div  class="cursorstyleObjBtn"  @click="InputBtn('trademark')">

					商标录入
				</div>
			</div>
			<div class="Notice_box_tpl">
				<!-- <div></div> -->
				<div>
					<el-table :data="tableDataTrademark" style="width:100%" class="tablebox">
						<el-table-column label="序号" align="center" width="50px">
							<template slot-scope="scope">
								<span>{{scope.$index+1}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" show-overflow-tooltip label="商标名称" align="center">
						</el-table-column>
						<el-table-column show-overflow-tooltip label="创建方式" align="center">
							<template slot-scope="scope">
                <span v-if="scope.row.create_type == '1'">自主申请</span>
                <span v-if="scope.row.create_type == '2'">自主录入</span>
                <span v-if="scope.row.create_type == '3'">后台录入</span>

              </template>
						</el-table-column>
						<el-table-column prop="status_txt" show-overflow-tooltip label="状态" align="center">
						</el-table-column>
						<el-table-column show-overflow-tooltip label="提交日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.create_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip label="授权日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.pass_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" >
							<template slot-scope="scope">
								<span  v-if="scope.row.status != 8 || scope.row.is_ok == 1" class="cursorstyle cursorstyleObjBtn" style="color: #409EFF;"
									@click="SeePatent(scope.row,'trademark')" type="text" size="small"> 查看</span>
								<span v-if="scope.row.status == 2 || scope.row.status ==5" class="cursorstyle cursorstyleObjBtn" style="color: #409EFF;"
									@click="editPatent(scope.row,'trademark')" type="text" size="small"> 编辑</span>
							</template>
						</el-table-column>

					</el-table>
				</div>
			</div>

			<div class="morebox cursorstyleObjBtn" @click="seeMore('trademark')">
				查看更多<img src="../assets/rightbtn.png">
			</div>
		</div>
		<!--    我的软著-->
		<div class="Notice_box stylePointer">
			<div class="Notice_box_title">
				<div>我的软著</div>
				<div @click="EnterBtn('soft')">
					<a href="#ApplicationManagement">软著申请</a>
				</div>
				<div class="cursorstyleObjBtn" @click="InputBtn('soft')">
          软著录入
				</div>
			</div>
			<div class="Notice_box_tpl">
				<!-- <div></div> -->
				<div>
					<el-table :data="tableDataSoftware" style="width:100%" class="tablebox">
						<el-table-column label="序号" align="center" width="50px">
							<template slot-scope="scope">
								<span>{{scope.$index+1}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" show-overflow-tooltip label="软著名称" align="center">
						</el-table-column>
						<!-- <el-table-column prop="type" show-overflow-tooltip label="专利类型" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.type == '1'">发明专利</span>
								<span v-if="scope.row.type == '2'">实用新型专利</span>
								<span v-if="scope.row.type == '3'">外观设计专利</span>
							</template>
						</el-table-column> -->
						<el-table-column show-overflow-tooltip label="创建方式" align="center">
							<template slot-scope="scope">
                <span v-if="scope.row.create_type == '1'">自主申请</span>
                <span v-if="scope.row.create_type == '2'">自主录入</span>
                <span v-if="scope.row.create_type == '3'">后台录入</span>

              </template>
						</el-table-column>
						<el-table-column prop="status_txt" show-overflow-tooltip label="状态" align="center">
							<!-- <template slot-scope="scope">
								<span v-if="scope.row.type == '1'">审核中</span>
								<span v-if="scope.row.type == '2'">被驳回</span>
								<span v-if="scope.row.type == '3'">补充材料</span>
								<span v-if="scope.row.type == '4'">国家知识产权平台审核</span>
								<span v-if="scope.row.type == '5'">已授权</span>
							</template> -->
						</el-table-column>
						<el-table-column show-overflow-tooltip label="提交日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.create_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip label="授权日期" align="center">
							<template slot-scope="scope">
								<span>{{userObj.dateFormat(scope.row.pass_time)}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="">
							<template slot-scope="scope">
								<span v-if="scope.row.status != 8 || scope.row.is_ok == 1" class=" cursorstyleObjBtn" style="color: #409EFF;" @click="SeePatent(scope.row,'soft')"
									type="text" size="small"> 查看</span>
								<span v-if="scope.row.status == 2 || scope.row.status ==5" class=" cursorstyleObjBtn" style="color: #409EFF;" @click="editPatent(scope.row,'soft')"
									type="text" size="small"> 编辑</span>
							</template>
						</el-table-column>



					</el-table>

				</div>

			</div>
			<div class="morebox cursorstyleObjBtn" @click="seeMore('soft')">
				查看更多<img src="../assets/rightbtn.png">
			</div>
		</div>
		<div class="coverBox" v-if="coverBox" id="ApplicationManagement">
			<login @coverBox="coverBoxfunction"></login>
		</div>
	</div>
</template>

<script>
	import login from "@/views/login.vue"
	import {
		GetlistPatentInterface,
		GetlistTrademarkInterface,
		GetlistSoftwareInterface
	} from '@/api/ApplicationManagement.js'
	import {
		loginInt
	} from '@/api/index.js'
	export default {
		data() {
			return {
				// 未登录的时候显示
				coverBox: false,
				// 专利列表
				tableDataPatent: [],
				// 商标列表
				tableDataTrademark: [],
				// 软著列表
				tableDataSoftware: []
			}
		},
		components: {
			login
		},
		mounted() {
			if (this.$route.query.coverBox) {
				this.coverBox = this.$route.query.coverBox
			}
			if (this.userObj.info() == null) {
				// this.coverBox = true
				return
			} else {
				// 获取专利列表
				this.GetlistPatent()
				// 获取商标
				this.GetlistTrademark()
				// 获取软著列表
				this.GetlistSoftware()
			}

		},
		methods: {
			coverBoxfunction(val) {
				this.coverBox = val.coverBox
				// 如果不是登录状态，跳转到登录页面
				if (this.userObj.info()) {
					// 获取专利列表
					this.GetlistPatent()
					// 获取商标
					this.GetlistTrademark()
					// 获取软著列表
					this.GetlistSoftware()
				}
			},
			// 专利录入
			applicationBtn() {
				this.$router.push('./patentApplication')
			},
			// 商标录入
			trademarkBtn() {
				this.$router.push('./TrademarkApplication')
			},
			// 软著录入
			softBtn() {
				this.$router.push('./SoftApply')
			},
			// 申请按钮
			EnterBtn(value) {
				// 如果不是登录状态，跳转到登录页面
				if (this.userObj.info() == null) {
					this.coverBox = true
					return
				}
				// 登录状态进行
				else if (value == 'patent') {
					this.$router.push('./patentApplication')
				} else if (value == 'trademark') {
					this.$router.push('./TrademarkApplication')
				} else if (value == 'soft') {
					this.$router.push('./SoftApply')
				}
			},
      // 录入按钮
      InputBtn(value) {
        // 如果不是登录状态，跳转到登录页面
        if (this.userObj.info() == null) {
          this.coverBox = true
          return
        }
        // 登录状态进行
        else if (value == 'patent') {
          this.$router.push({path:'patentApplication',query:{create_type:'2'}})
        } else if (value == 'trademark') {
          this.$router.push({path:'TrademarkApplication',query:{create_type:'2'}})
        } else if (value == 'soft') {
          this.$router.push({path:'SoftApplyEnter',query:{create_type:'2'}})
        }
      },

			// 查看更多
			seeMore(value) {

				// 如果不是登录状态，跳转到登录页面
				if (this.userObj.info() == null) {
					this.coverBox = true
					return
				} else if (value == 'patent') {
					this.$router.push('./patentSeeMore')
				} else if (value == 'trademark') {
					this.$router.push('./trademarkSeeMore')
				} else if (value == 'soft') {
					this.$router.push('./softSeeMore')
				}
			},
			// 查看列表
			SeePatent(row, value) {
				// 如果不是登录状态，跳转到登录页面
				if (this.userObj.info() == null) {
					this.coverBox = true
					return
				} else if (value == 'patent') {

					// this.$router.push({
					// 	path: './patentApplication',
					// 	query: {
					// 		mark: 'see',
					// 		ids: row.id
					// 	}
					// })


          if(row.nature == 1){
            this.$router.push({
              path: './patentSeeMore_seeInvention',
              query: {
                mark: 'see',
                ids: row.id
              }
            })
          }else {
            this.$router.push({
              path: './patentSeeMore_seeOthertypes',
              query: {
                mark: 'see',
                ids: row.id
              }
            })
          }





				} else if (value == 'trademark') {
					// this.$router.push('./trademarkSeeMore')
					// this.$router.push({
					// 	path: './TrademarkApplication',
					// 	query: {
					// 		mark: 'see',
					// 		ids: row.id
					// 	}
					// })

          this.$router.push({path:'./trademarkSeeMore_seeObj',query:{mark:'see',ids:row.id}})

        } else if (value == 'soft') {
					// this.$router.push({
					// 	path: './SoftApply',
					// 	query: {
					// 		mark: 'see',
					// 		ids: row.id
					// 	}
					// })

          this.$router.push({path:'./softSeeMore_seeObj',query:{mark:'see',ids:row.id}})



        }
			},
			editPatent(row, value) {
				// this.$router.push({path:'./patentApplication',query:{mark:'edit',ids:vlaue.id}})
				// 如果不是登录状态，跳转到登录页面
				if (this.userObj.info() == null) {
					this.coverBox = true
					return
				} else if (value == 'patent') {

          if(row.nature == 1){
            this.$router.push({
              path: './patentApplication',
              query: {
                mark: 'edit',
                ids: row.id,
              }
            })
          }else {
            this.$router.push({
              path: './patentApplication',
              query: {
                mark: 'edit',
                ids: row.id,
                create_type:row.create_type
              }
            })
          }



				} else if (value == 'trademark') {
					// this.$router.push('./trademarkSeeMore')
					this.$router.push({
						path: './TrademarkApplication',
						query: {
							mark: 'edit',
							ids: row.id
						}
					})
				} else if (value == 'soft') {
					this.$router.push({
						path: './SoftApply',
						query: {
							mark: 'edit',
							ids: row.id
						}
					})
				}
			},
			//获取专利列表
			async GetlistPatent(vlaue) {
				let res = await GetlistPatentInterface()
				if (res.code == "00000") {
					this.tableDataPatent = res.data.result
				}
			},
			// 获取商标列表
			async GetlistTrademark(vlaue) {
				let res = await GetlistTrademarkInterface()
				if (res.code == "00000") {
					this.tableDataTrademark = res.data.result
				}
			},
			async GetlistSoftware(vlaue) {
				let res = await GetlistSoftwareInterface()
				if (res.code == "00000") {
					this.tableDataSoftware = res.data.result
				}
			},


		}
	}
</script>

<style scoped="scoped" lang="less">
	/*内容*/
	.bodybox {
		width: 63vw;
		margin: 0 auto;
		margin-top: 20px;
		/*border: green solid 1px;*/
	}

	.bodybox>div {
		box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.12);
		border-radius: 8px;
		margin-top: 20px;
		overflow: hidden;
	}

	.Electronics {
		width: 100%;
		height: 115px;
		background: #FFFFFF;
	}

	.Electronics>p {
		font-weight: bold;
		color: #333333;
		line-height: 24px;
		margin-top: 10px;
		margin-left: 10px;
		font-size: 1.13rem;
	}

	.Electronics>div {
		width: 98%;
		margin: 0 auto;
		margin-top: 10px;
	}

	.ElectronicsItem {
		height: 47px;
		background: #ECF4FF;
	}

	.ElectronicsItem>div {
		display: inline-block;
		font-size: 0.88rem;
		color: #333333;
		line-height: 47px;
		margin-right: 6px;
	}

	.ElectronicsItem>div img {
		vertical-align: middle;
		margin-right: 6px;
		width: 1.6vw;
	}

	.ElectronicsItem>div:first-child {
		background: #085BB9;
		width: 5.4vw;
		text-align: center;
		border-radius: 5px 0px 0px 5px;
		color: #FFFFFF;
	}

	/*    我的专利*/
	.Notice_box {
		margin-top: 20px;
		// height: 390px;
		padding: 10px;
	}

	.Notice_box_tpl {
		width: 98%;
		display: flex;
		margin: 0 auto;
		margin-top: 10px;
	}

	// .Notice_box_tpl>div {
	// 	display: inline-block;
	// }

	// .Notice_box_tpl>div:first-child {
	// 	width: 30%;
	// 	height: 26vh;
	// 	background: #9B9B9B;
	// 	border-radius: 5px;
	// 	margin-right: 20px;
	// }

	.Notice_box_tpl>div:nth-child(1) {
		width: 100%;
		height: 25.2vh;
		border: 1px solid #E5E5E5;
		overflow: hidden;
	}



	.Notice_box_title {
		width: 98%;
		margin: 0 auto;
		margin-top: 14px;
		// border: 1px red solid;
		height: 4vh;
	}

	.Notice_box_title>div {
		display: inline-block;
	}

	.Notice_box_title>div:first-child {
		font-size: 1.12rem;
		font-weight: bold;
		color: #333333;
	}

	.Notice_box_title>div:nth-child(3) {
		float: right;
		width: 77px;
		height: 28px;
		background: #0985BE;
		border-radius: 14px;
		font-size: 0.88rem;
		color: #FFFFFF;
		text-align: center;
		line-height: 28px;
		margin-right: 10px;
	}

	.Notice_box_title>div:nth-child(2) {
		float: right;
		width: 77px;
		height: 28px;
		background: #0D68BB;
		border-radius: 14px;
		font-size: 0.88rem;
		color: #FFFFFF;
		text-align: center;
		line-height: 28px;
	}

	/* morebox */
	.morebox {
		width: 164px;
		height: 34px;
		// background: url(../assets/img/矩形.png) no-repeat center;
		// margin: 0 auto;
		float: right;
		text-align: center;
		line-height: 34px;
		font-size: 0.88rem;
		color: #666666;
		margin-top: -2px;

	}

	.morebox>img {
		vertical-align: middle;
	}

	/* table */
	.tablebox {
		width: 100%;
		margin: 0 auto;
	}
	/deep/.el-table::before {
	    left: 0;
	    bottom: 0;
	    width: 100%;
	   height: 0px !important;
	}
	
	/deep/.el-table__header th {
			padding: 0;
			line-height: 3.6vh;
			height: 3.6vh;
			background: rgba(216, 216, 216, 0.2);
			font-weight: bold;
			color: #333333;
			font-size: 0.88rem;
		}
	
		/deep/ .el-table__body td {
			padding: 0;
			height: 3.6vh;
			line-height: 3.6vh;
			color: #333333;
			font-size: 0.88rem;
		}


	// 登录的遮罩盒子
	.coverBox {
		position: absolute;
		top: -19px;
		left: 0;
		width: 100vw;
		height: 198%;
		background-color: rgba(0, 0, 0, 0.3);
	}

	a {
		text-decoration: none;
		color: #fff;
	}


  /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
    cursor:pointer !important;
  }
</style>
